import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";
import RentalReservation from "./RentalReservation";

export default function RentalFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const [reservingItem, setReservingItem] = useState(null);

  const categories = [
    { id: "all", name: "Todos" },
    { id: "car", name: "Carros" },
    { id: "house", name: "Imóveis" },
    { id: "equipment", name: "Equipamentos" },
    { id: "electronics", name: "Eletrônicos" },
    { id: "sports", name: "Esportes" },
    { id: "party", name: "Festas" },
    { id: "tools", name: "Ferramentas" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/rental?page=${pageNum}&limit=12`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching rentals:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  const handleEditPost = (post) => {
    setSelectedItem(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedItem(null);
  };

  const handleReserveClick = (post) => {
    setSelectedItem(null);
    setReservingItem(post);
  };

  const handleReservationSuccess = (data) => {
    console.log("Reserva criada:", data);
    // Atualizar o post na lista
    fetchPosts(1);
  };

  if (loading && posts.length === 0) {
    return <div className="rental_feed_loading"><div className="rental_loader"></div><span>Carregando aluguéis...</span></div>;
  }

  return (
    <div className="rental_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="rental_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
          </svg>
          <h3>Nenhum item para alugar</h3>
          <p>Seja o primeiro a anunciar!</p>
        </div>
      ) : (
        <div className="rental_grid">
          {posts.map((post) => (
            <div key={post._id} className="rental_card" onClick={() => setSelectedItem(post)}>
              <div className="rental_image">
                <img src={post.rentalData?.images?.[0] || post.images?.[0]?.url || post.images?.[0] || "/images/default-rental.png"} alt="" />
                <span className="rental_category_badge">
                  {categories.find(c => c.id === post.rentalData?.category)?.name || "Outros"}
                </span>
                {post.rentalData?.availability === "available" && (
                  <span className="rental_available_badge">Disponível</span>
                )}
                {post.rentalData?.availability === "rented" && (
                  <span className="rental_rented_badge">Alugado</span>
                )}
              </div>
              <div className="rental_card_content">
                <h3>{post.rentalData?.itemName || post.text}</h3>
                <p className="rental_condition">
                  Condição: <strong>{post.rentalData?.condition === "new" ? "Novo" : post.rentalData?.condition === "like_new" ? "Seminovo" : "Usado"}</strong>
                </p>
                <p className="rental_location">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  </svg>
                  {post.rentalData?.location || "Não informado"}
                </p>
                <div className="rental_footer">
                  <div className="rental_price">
                    <span className="rental_price_value">R$ {(post.rentalData?.pricePerDay || 0).toFixed(0)}</span>
                    <span className="rental_price_label">/dia</span>
                  </div>
                  {post.rentalData?.deposit > 0 && (
                    <span className="rental_deposit">Caução: R$ {post.rentalData.deposit.toFixed(0)}</span>
                  )}
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="rental_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {reservingItem && (
        <RentalReservation
          post={reservingItem}
          onClose={() => setReservingItem(null)}
          onSuccess={handleReservationSuccess}
        />
      )}

      {selectedItem && (
        <div className="rental_modal_overlay" onClick={() => setSelectedItem(null)}>
          <div className="rental_modal" onClick={(e) => e.stopPropagation()}>
            <button className="rental_modal_close" onClick={() => setSelectedItem(null)}>✕</button>
            <div className="rental_modal_gallery">
              <img src={selectedItem.rentalData?.images?.[0] || selectedItem.images?.[0]} alt="" />
            </div>
            <div className="rental_modal_body">
              <span className="rental_modal_category">
                {categories.find(c => c.id === selectedItem.rentalData?.category)?.name}
              </span>
              <h2>{selectedItem.rentalData?.itemName}</h2>
              <p className="rental_modal_desc">{selectedItem.rentalData?.description || selectedItem.text}</p>

              <div className="rental_modal_details">
                <div className="rental_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  </svg>
                  <span>{selectedItem.rentalData?.location || "Não informado"}</span>
                </div>
                <div className="rental_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                  <span>Condição: {selectedItem.rentalData?.condition === "new" ? "Novo" : selectedItem.rentalData?.condition === "like_new" ? "Seminovo" : "Usado"}</span>
                </div>
                <div className="rental_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                  </svg>
                  <span>Caução: R$ {(selectedItem.rentalData?.deposit || 0).toFixed(0)}</span>
                </div>
              </div>

              <Link to={`/profile/${selectedItem.user.username}`} className="rental_owner">
                <img src={selectedItem.user.picture} alt="" />
                <div>
                  <span className="rental_owner_label">Anunciante</span>
                  <span className="rental_owner_name">{selectedItem.user.first_name} {selectedItem.user.last_name}</span>
                </div>
              </Link>

              <div className="rental_modal_footer">
                <div className="rental_modal_price">
                  <span>R$ {(selectedItem.rentalData?.pricePerDay || 0).toFixed(0)}</span>
                  <span> /dia</span>
                </div>
                {selectedItem.rentalData?.availability === "available" && selectedItem.user._id !== user.id && (
                  <button 
                    className="rental_reserve_btn" 
                    onClick={() => handleReserveClick(selectedItem)}
                  >
                    Reservar Agora
                  </button>
                )}
                {selectedItem.rentalData?.availability !== "available" && (
                  <button className="rental_reserve_btn_disabled" disabled>
                    Indisponível
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
